import { MsalContext } from "@azure/msal-react";
import Buttons, { ButtonType } from "@deloitte-omnia/core-fe-mfe/Buttons";
import SvgIcon from "@deloitte-omnia/core-fe-mfe/SvgIcon";
import ToolTip, { ToolTipPosition } from "@deloitte-omnia/core-fe-mfe/ToolTip";
import Alert from "@mui/material/Alert";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { getUserImage } from "../../actions/PTOActions";
import UserGuide from "../../assets/docs/AuditAndAssurancePTOGuidelines.pdf";
import LogoDeloitte from "../../assets/images/deloitte_logo_black.edbacd33.svg";
import ErrorBoundaryComponent from "../../components/ErrorHandle/errorBoundary";

const mapStateToProps = (state) => ({
  employeesData: state.pto.employeeData,
  userDetails: state.pto.getUserDetails,
  requestType: state.pto.requestType,
  businessRulesFlexibility: state.businessRules.businessRulesFlexibility,
  unknownRulesData: state.businessRules.unknownRulesData,
  userImage: state.pto.userImage,
  notificationMessage: state.pto.notificationMessage,
});

const mapDispatchToProps = (dispatch) => ({
  getUserImage: (payload) => dispatch(getUserImage(payload)),
});
class ProjectHeader extends Component {
  static contextType = MsalContext;

  constructor(props) {
    super(props);
    this.state = {
      imageUrl: null,
      //variant: AlertVariants.Error,
      showAlertMessage: "BackDated Are Disabled between these variants",
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.navigateHelperPage = this.navigateHelperPage.bind(this);
    this.navigateToHome = this.navigateToHome.bind(this);
  }

  componentDidMount() {
    this.getUserImage();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userDetails?.user?.email !== this.props.userDetails?.user?.email
    ) {
      this.setState({ imageUrl: null });
      this.getUserImage();
    }
    if (this.props.userImage !== null && this.state.imageUrl === null) {
      this.getUserImage();
    }
  }

  handleLogout(instance) {
    const msalInstance = instance;
    try {
      msalInstance.logoutRedirect();
    } catch (error) {
      // Handle or log the error
    }
  }

  navigateHelperPage() {
    window.open(UserGuide, "_blank");
  }

  navigateToHome() {
    this.props.history.push("/");
  }

  getUserImage() {
    this.setState({ imageUrl: this.props.userImage });
  }

  render() {
    const { imageUrl, errors } = this.state;
    let employeeName;
    let industry;
    let name;
    let check = false;
    let userInitial;
    let userFirstName;
    let userLastName;
    let splitNames;

    if (this.props.userDetails !== undefined) {
      if (this.props.userDetails?.user !== undefined && check === false) {
        check = true;
        employeeName = this.props.userDetails?.user?.name;
        industry = this.props.userDetails?.user?.currentCluster;
        name = `${employeeName},      ${industry}`;
        splitNames = employeeName?.split(",");

        if (splitNames?.length > 1) {
          userFirstName = splitNames[0].trim()[0];
          userLastName = splitNames[1].trim()[0];
          userInitial = userLastName.concat(userFirstName);
        } else {
          userInitial = splitNames?.[0]
            ? splitNames[0].trim().substring(0, 2)
            : "";
        }
      }
    }

    return (
      <React.Fragment>
        <header className="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar">
          <img
            className="d-inline-block align-top"
            src={LogoDeloitte}
            width="86px"
            height="21px"
            alt="deloitte-logo"
            style={{ cursor: "pointer" }}
            onClick={this.navigateToHome}
          />
          <ul className="navbar-nav flex-row ml-md-auto d-md-flex">
            <div className="svgIcon" onClick={this.navigateHelperPage}>
              <SvgIcon identifier="#miniquestionmark" dataTHS="helper-icon" />
            </div>
            <li className="header">
              <UncontrolledDropdown nav inNavbar id="userinfo">
                <DropdownToggle nav caret>
                  <Media className="mt-1">
                    <Media left middle href="#" className="col-md-3"></Media>
                    <Media body className="ml-2 text-left d-flex">
                      <span>
                        <img
                          style={{ borderRadius: "50px" }}
                          src={
                            errors === false ? (
                              <SvgIcon identifier="#user" dataTHS="user-icon" />
                            ) : (
                              imageUrl
                            )
                          }
                          alt="user-logo"
                          height="43"
                          width="auto"
                        />
                      </span>
                      <ToolTip value={name} position={ToolTipPosition.left}>
                        <span className="d-block">
                          <span className="mx-2">
                            <Buttons
                              className="userPreference userPreferenceButton"
                              type={ButtonType.none}
                            >
                              {userInitial}
                            </Buttons>
                          </span>
                        </span>
                      </ToolTip>
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem
                    onClick={() => this.handleLogout(this.context.instance)}
                    style={{ fontSize: "15px" }}
                  >
                    Logout
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </li>
          </ul>
        </header>
        {this.props.userDetails &&
          this.props?.userDetails?.user !== undefined && (
            <Row className="user-info">
              <Col xs="2" sm="2" md="2" lg="2" xl="2">
                <div className="applicationName_Color">Audit PTO Tracker</div>
              </Col>
              <Col xs="9" sm="9" md="9" lg="9" xl="9">
                <div className="align-center">
                  <div className="user-info-sub-sec user-info-sub-sec-padding">
                    Welcome!&nbsp;{this.props.userDetails?.user?.name}
                  </div>
                  <div className="user-info-sub-sec user-info-sub-sec-padding">
                    Access Type:&nbsp;{this.props.userDetails?.user?.roleName}
                  </div>
                  <div className="user-info-sub-sec user-info-sub-sec-padding">
                    Industry:&nbsp;{this.props.userDetails?.user?.industry}
                  </div>
                  <div className="user-info-sub-sec user-info-sub-sec-padding">
                    {" "}
                    Current Cluster:&nbsp;
                    {this.props.userDetails?.user?.currentCluster}
                  </div>
                </div>
              </Col>
              <Col xs="auto" sm="auto" md="auto" lg="auto" xl="auto"></Col>
            </Row>
          )}
        <Row className="minimized-row">
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <div className="banner_height">
              <Alert severity="warning" className="bannerMessage alert">
                <div className="notification_header">
                  {this.props?.notificationMessage?.message}
                </div>
              </Alert>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

ProjectHeader.propTypes = {
  getUserImage: PropTypes.func.isRequired,
  userImage: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  notificationMessage: PropTypes.string,
  userDetails: PropTypes.shape({
    length: PropTypes.array.isRequired,
    user: PropTypes.shape({
      currentCluster: PropTypes.any,
      email: PropTypes.shape({
        split: PropTypes.func,
      }),
      name: PropTypes.any,
      industry: PropTypes.any,
      roleName: PropTypes.any,
    }),
  }),
};

const ConnectedComponentProjectHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectHeader);
const ErrorHandledComponentProjectHeader = (props) => {
  return (
    <ErrorBoundaryComponent>
      <ConnectedComponentProjectHeader {...props} />
    </ErrorBoundaryComponent>
  );
};

export default withRouter(ErrorHandledComponentProjectHeader);
